import { faPlus } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router';

import useTranslation from 'hooks/useTranslation';

const CreateButton = () => {
	const navigate = useNavigate();
	const { t } = useTranslation();
	return (
		<button
			type="button"
			className="btn btn-primary"
			onClick={() => {
				navigate('/shoppingCart/new');
			}}
		>
			<FontAwesomeIcon icon={faPlus} size="lg" style={{ marginRight: '10px' }} />
			{t('shoppingCart:CREATE_SHOPPING_CART')}
		</button>
	);
};

export default CreateButton;
